// extracted by mini-css-extract-plugin
export var errorIcon = "_pl-1";
export var nameLogo = "_pl-0";